module.exports = __webpack_public_path__ + "img/grey-info.0c35e2fc.svg";